/* ============================================================
   OCEMIDA — Survey wizard state + results + cart wiring
   Reads window.Ocemida (variantId, redirectToCart).
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.Ocemida || {};
  var root = document.querySelector('[data-ocemida]');
  if (!root) return;

  var $ = function (sel, scope) { return (scope || root).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); };

  var sections = $$('.main-section');
  var railLis = $$('#rail-list li');
  var railProg = $('#rail-progress');
  var revealBtn = $('#reveal');
  var msg = $('#cart-msg');
  var stepBackBtn = $('#step-back');
  var stepNextBtn = $('#step-next');
  var stepNavKicker = $('#step-nav-kicker');
  var stepNavTitle = $('#step-nav-title');
  var stepNavNote = $('#step-nav-note');
  var dz = $('.dropzone');
  var fileInp = $('#dz-file');
  var fileBtn = $('.file-btn');
  var fileName = $('.file-name');
  var labFileData = null; // { name, type, base64 }
  var requiredSteps = ['1', '2', '3', '4', '5', '6', '7'];
  var activeIdx = 0;
  var maxReachedIdx = 0;
  var surveyReferenceCode = createReferenceCode();

  function setText(sel, text, scope) {
    var el = (scope || root).querySelector(sel);
    if (el && text != null) el.textContent = text;
  }

  function getStepCount() {
    return sections.length;
  }

  function createReferenceCode() {
    var now = new Date();
    var year = String(now.getFullYear()).slice(-2);
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    var hours = String(now.getHours()).padStart(2, '0');
    var minutes = String(now.getMinutes()).padStart(2, '0');
    var random = Math.random().toString(36).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
    return 'OCM-' + year + month + day + '-' + hours + minutes + '-' + random;
  }

  function getSection(index) {
    return sections[index] || null;
  }

  function getCurrentSection() {
    return getSection(activeIdx);
  }

  function markTouched(el) {
    var sec = el && el.closest && el.closest('.main-section');
    if (sec) sec.classList.add('touched');
  }

  function afterInteraction(el) {
    markTouched(el);
    readSurvey();
  }

  function canVisitStep(index) {
    return index <= maxReachedIdx;
  }

  function setSliderValue(track, value, touched) {
    var fill = $('.oc-slider-fill', track);
    var knob = $('.oc-slider-knob', track);
    var pct = Math.max(0, Math.min(100, value));
    if (fill) fill.style.width = pct + '%';
    if (knob) knob.style.left = pct + '%';
    track.dataset.value = String(Math.round(pct));
    track.setAttribute('aria-valuenow', String(Math.round(pct)));
    if (touched) track.classList.add('is-touched');
  }

  function describeSlider(track) {
    if (!track || !track.classList.contains('is-touched')) return '';
    var value = parseInt(track.dataset.value || '0', 10);
    var marks = $$('.oc-slider-marks span', track.parentNode);
    if (marks.length === 2) {
      if (value < 50) return marks[0].textContent.trim();
      if (value > 50) return marks[1].textContent.trim();
      return 'Balanced';
    }
    if (marks.length === 3) {
      if (value < 33) return marks[0].textContent.trim();
      if (value < 66) return marks[1].textContent.trim();
      return marks[2].textContent.trim();
    }
    return value + '%';
  }

  function sliderSummary(key) {
    return describeSlider($('.oc-slider-track[data-q="' + key + '"]'));
  }

  function isComplete(sec) {
    if (!sec) return false;
    var step = sec.dataset.step;
    if (step === '1') {
      return !!$('[data-q="sex_at_birth"] .chip.on', sec)
        && !!$('[data-q="age_range"] .chip.on', sec)
        && !!$('[data-q="current_brand"] .chip.on', sec);
    }
    if (step === '2') {
      return !!$('[data-q="type"] .opt.on', sec)
        && !!$('.oc-slider-track[data-q="thickness"].is-touched', sec)
        && !!$('[data-q="density"] .chip.on', sec);
    }
    if (step === '3') return $$('[data-q="allergies"] .check.on', sec).length > 0;
    if (step === '4') return $$('[data-q="scalp-concerns"] .scalp-opt.on', sec).length > 0;
    if (step === '5') return $$('[data-q="goals"] .chip.on', sec).length > 0;
    if (step === '6') {
      return !!$('[data-q="workout"] .chip.on', sec)
        && !!$('[data-q="diet"] .chip.on', sec)
        && !!$('[data-q="stress"] .chip.on', sec)
        && !!$('[data-q="sun"] .chip.on', sec);
    }
    if (step === '7') {
      return !!$('[data-q="length"] .length-opt.on', sec)
        && !!$('[data-q="wash"] .chip.on', sec)
        && !!$('.oc-slider-track[data-q="heat"].is-touched', sec);
    }
    if (step === '8') return !!$('.dropzone.has-file', sec);
    if (step === '9') return true;
    return false;
  }

  function updateHeader() {
    var current = getCurrentSection();
    setText('#step-meta-num', String(activeIdx + 1));
    setText('#step-meta-title', current ? (current.dataset.title || '') : '');
  }

  function updateSummaryMode() { /* aside removed; nothing to update here */ }

  function updateNav() {
    var current = getCurrentSection();
    if (!current) return;

    var step = current.dataset.step;
    var done = isComplete(current);
    var first = activeIdx === 0;
    var final = step === '9';
    var optional = current.dataset.optional === 'true';

    if (stepBackBtn) {
      stepBackBtn.disabled = first;
      stepBackBtn.style.visibility = first ? 'hidden' : 'visible';
    }

    if (stepNavKicker) stepNavKicker.textContent = 'Step ' + (activeIdx + 1) + ' of ' + getStepCount();

    if (final) {
      if (stepNextBtn) stepNextBtn.hidden = true;
      if (stepNavTitle) stepNavTitle.textContent = 'Review your results';
      if (stepNavNote) stepNavNote.textContent = 'Use Back or the step rail to make changes before ordering. Your reference code will follow the order into fulfillment.';
      return;
    }

    if (stepNextBtn) {
      stepNextBtn.hidden = false;
      if (optional) {
        stepNextBtn.disabled = false;
        stepNextBtn.textContent = done ? 'See Results' : 'Skip for Now';
      } else {
        stepNextBtn.disabled = !done;
        stepNextBtn.textContent = 'Continue';
      }
    }

    if (optional) {
      if (stepNavTitle) stepNavTitle.textContent = done ? 'Lab insights added' : 'Optional step';
      if (stepNavNote) stepNavNote.textContent = done
        ? 'Your upload is saved. Use Continue to move to your results.'
        : 'Add a report for deeper personalization, or skip straight to your results.';
      return;
    }

    if (stepNavTitle) stepNavTitle.textContent = done ? 'Ready for the next screen' : 'Complete this step to continue';
    if (stepNavNote) stepNavNote.textContent = done
      ? 'Your answers are saved. Use Continue when you are ready.'
      : 'Fill the required answers on this screen to enable Continue.';
  }

  function updateProgress(doneCount) {
    var totalSteps = Math.max(requiredSteps.length, 1);
    var completedRailSteps = sections.filter(function (sec) {
      return sec.dataset.step !== '7' && isComplete(sec);
    }).length;
    var pct = Math.round((doneCount / totalSteps) * 100);
    var bar = $('#progress-bar');
    var pctEl = $('#progress-pct');
    if (bar) bar.style.width = pct + '%';
    if (pctEl) pctEl.innerHTML = '<strong>' + pct + '%</strong> Complete';
    if (railProg) railProg.style.height = (Math.max(maxReachedIdx, completedRailSteps) / Math.max(getStepCount() - 1, 1)) * 100 + '%';

    var stickyFill = document.getElementById('sticky-progress-fill');
    var stickyPct = document.getElementById('sticky-progress-pct');
    var stickyStep = document.getElementById('sticky-progress-step');
    if (stickyFill) stickyFill.style.width = pct + '%';
    if (stickyPct) stickyPct.textContent = pct + '%';
    if (stickyStep) stickyStep.textContent = 'Step ' + (activeIdx + 1) + ' of ' + getStepCount();

    if (revealBtn) {
      var configError = revealBtn.getAttribute('data-config-error') || '';
      var configured = !configError && !!cfg.variantId;
      var ready = doneCount === requiredSteps.length;
      console.log('Reveal button check:', {
        doneCount: doneCount,
        requiredSteps: requiredSteps.length,
        ready: ready,
        configError: configError,
        variantId: cfg.variantId,
        configured: configured,
        disabled: !ready || !configured
      });
      revealBtn.disabled = !ready;
      revealBtn.classList.toggle('is-blocked', !configured);
      var label = $('.reveal-label', revealBtn);
      if (label) {
        if (ready) label.textContent = 'ORDER MY CUSTOM FORMULA';
        else label.textContent = 'Complete required steps to continue';
      }
    }
  }

  function updateStatuses(doneCount) {
    sections.forEach(function (sec, index) {
      var step = sec.dataset.step;
      var done = isComplete(sec);
      var statusEl = $('.section-status', sec);
      var active = index === activeIdx;
      var visited = index <= maxReachedIdx;

      sec.classList.toggle('complete', done);

      if (!statusEl) return;

      if (step === '9') {
        statusEl.textContent = doneCount === requiredSteps.length ? 'Ready to order' : 'Final step';
        return;
      }

      if (sec.dataset.optional === 'true') {
        statusEl.textContent = done ? 'Added' : 'Optional';
        return;
      }

      if (done) {
        statusEl.textContent = 'Complete';
      } else if (active || sec.classList.contains('touched')) {
        statusEl.textContent = 'In progress';
      } else if (visited) {
        statusEl.textContent = 'Not started';
      } else {
        statusEl.textContent = 'Locked';
      }
    });

    railLis.forEach(function (li, index) {
      var sec = sections[index];
      if (!sec) return;

      var step = sec.dataset.step;
      var done = isComplete(sec);
      var active = index === activeIdx;
      var locked = !canVisitStep(index) && !active;
      var meta = $('.meta', li);

      li.classList.toggle('active', active);
      li.classList.toggle('done', done);
      li.classList.toggle('locked', locked);

      if (!meta) return;

      if (locked) meta.textContent = 'locked';
      else if (step === '9') meta.textContent = active ? 'results' : 'final step';
      else if (sec.dataset.optional === 'true') meta.textContent = done ? 'added' : 'optional';
      else if (active) meta.textContent = 'in progress';
      else if (done) meta.textContent = 'complete';
      else meta.textContent = 'not started';
    });
  }

  function setResultItem(sel, text, placeholderText) {
    var el = $(sel);
    if (!el) return;
    var empty = !text || text === '—';
    el.textContent = empty ? (placeholderText || '—') : text;
    el.classList.toggle('placeholder', empty);
  }

  function readSurvey() {
    var typeOpt = $('[data-q="type"] .opt.on');
    var typeLabel = typeOpt
      ? (($('.lbl-big', typeOpt) || {}).textContent || '').trim() + ' ' + (($('.lbl-sm', typeOpt) || {}).textContent || '').trim()
      : '';
    typeLabel = typeLabel.trim();

    var goals = $$('[data-q="goals"] .chip.on').map(function (btn) { return btn.textContent.trim(); });
    var concerns = $$('[data-q="scalp-concerns"] .scalp-opt.on').map(function (item) {
      return (($('.lbl', item) || {}).textContent || '').trim();
    }).filter(Boolean);
    var cond = $$('[data-q="condition"] .check.on').map(function (item) { return item.textContent.trim(); });
    var allergies = $$('[data-q="allergies"] .check.on').map(function (item) { return item.textContent.trim(); });
    var len = $('[data-q="length"] .length-opt.on');
    var lengthLabel = len ? (($('.lbl', len) || {}).textContent || '').trim() : '';
    var density = (($('[data-q="density"] .chip.on') || {}).textContent || '').trim();
    var sexAtBirth = (($('[data-q="sex_at_birth"] .chip.on') || {}).textContent || '').trim();
    var sexAtBirthResult = sexAtBirth
      ? (sexAtBirth === 'Prefer Not to Say' ? 'Prefer not to say' : sexAtBirth)
      : '';
    var thickness = sliderSummary('thickness');
    var heat = sliderSummary('heat');
    var labFile = (fileName && fileName.textContent ? fileName.textContent.trim() : '');

    var selects = {};
    $$('.oc-select').forEach(function (select) {
      if (select.name) selects[select.name] = select.value;
    });
    // Read chip values for single-select chip groups
    var chipValues = ['workout', 'diet', 'stress', 'sun', 'age_range', 'current_brand', 'wash'];
    chipValues.forEach(function (key) {
      var chip = $('[data-q="' + key + '"] .chip.on');
      if (chip) selects[key] = chip.textContent.trim();
    });

    var inputs = {};
    $$('.oc-input').forEach(function (input) {
      if (input.name) inputs[input.name] = (input.value || '').trim();
    });

    var toggles = {};
    $$('.toggle[data-q]').forEach(function (toggle) {
      toggles[toggle.dataset.q] = toggle.classList.contains('on');
    });

    var sliders = {};
    $$('.oc-slider-track[data-q]').forEach(function (track) {
      sliders[track.dataset.q] = {
        value: track.dataset.value || '',
        label: describeSlider(track),
        touched: track.classList.contains('is-touched')
      };
    });

    var counter = $('#goals-counter');
    if (counter) counter.innerHTML = '<strong>' + goals.length + '</strong> / 3 selected';

    $$('.oc-slider-track[data-q]').forEach(function (track) {
      var label = root.querySelector('[data-slider-label="' + track.dataset.q + '"]');
      if (!label) return;

      var text = describeSlider(track);
      if (!track.classList.contains('is-touched')) {
        label.textContent = 'Tap to set';
        label.classList.add('placeholder');
        return;
      }

      label.classList.remove('placeholder');
      label.textContent = text;
    });

    setResultItem('#result-profile', [
      sexAtBirthResult,
      selects.age_range ? 'Age ' + selects.age_range : '',
      typeLabel,
      density ? density + ' density' : '',
      thickness ? 'Thickness: ' + thickness : '',
      selects.current_brand ? 'Currently uses: ' + selects.current_brand + (inputs.current_brand_name ? ' (' + inputs.current_brand_name + ')' : '') : '',
      allergies.length ? 'Avoids: ' + allergies.join(', ') + (inputs.allergies_other ? ', ' + inputs.allergies_other : '') : ''
    ].filter(Boolean).join(' · '), '—');
    setResultItem('#result-condition', cond.length ? cond.join(', ') : '', 'None selected');
    setResultItem('#result-goals', goals.length ? goals.join(', ') : '', '—');
    setResultItem('#result-scalp', concerns.length ? concerns.join(', ') : '', '—');
    setResultItem('#result-lifestyle', [
      selects.workout ? 'Workout: ' + selects.workout : '',
      selects.diet ? 'Diet: ' + selects.diet : '',
      selects.stress ? 'Stress: ' + selects.stress : '',
      selects.sun ? 'Sun exposure: ' + selects.sun : '',
      'Pollution: ' + (toggles.pollution ? 'Yes' : 'No'),
      'Hard water: ' + (toggles.hardwater ? 'Yes' : 'No'),
      'Pool / salt: ' + (toggles.poolswim ? 'Yes' : 'No'),
      'Low sleep: ' + (toggles.sleep ? 'Yes' : 'No')
    ].filter(Boolean).join(' · '), '—');
    setResultItem('#result-hairstyle', [
      lengthLabel,
      heat ? 'Heat styling: ' + heat : '',
      selects.wash ? 'Wash routine: ' + selects.wash : ''
    ].filter(Boolean).join(' · '), '—');
    setResultItem('#result-lab', labFile || '', 'Not added');
    setResultItem('#result-reference', surveyReferenceCode, surveyReferenceCode);

    var doneCount = 0;
    sections.forEach(function (sec) {
      if (requiredSteps.indexOf(sec.dataset.step) > -1 && isComplete(sec)) doneCount++;
    });

    updateStatuses(doneCount);
    updateProgress(doneCount);
    updateNav();
    updateSummaryMode();

    var typeCode = (typeOpt && typeOpt.dataset.value) ? typeOpt.dataset.value : '';
    var allergyOther = inputs.allergies_other || '';
    var brandTier = selects.current_brand || '';
    var brandName = inputs.current_brand_name || '';

    var survey = {
      referenceCode: surveyReferenceCode,
      type: typeLabel,
      typeCode: typeCode,
      density: density,
      sexAtBirth: sexAtBirth,
      ageRange: selects.age_range || '',
      thickness: thickness,
      thicknessValue: parseInt((sliders.thickness || {}).value || '50', 10),
      condition: cond,
      concerns: concerns,
      goals: goals,
      length: lengthLabel,
      heat: heat,
      heatValue: parseInt((sliders.heat || {}).value || '50', 10),
      allergies: allergies,
      allergyOther: allergyOther,
      brandTier: brandTier,
      brandName: brandName,
      labFile: labFile,
      selects: selects,
      toggles: toggles,
      sliders: sliders
    };

    survey.formula = buildFormula(survey);
    root._ocSurvey = survey;
    renderRailPreview(survey, doneCount);
  }

  function renderRailPreview(survey, doneCount) {
    var preview = document.getElementById('rail-preview');
    if (!preview) return;
    var f = (survey && survey.formula) || {};
    var pool = []
      .concat(f.actives || [])
      .concat(f.scalp || [])
      .concat(f.condition || [])
      .concat(f.lifestyle || []);
    var seen = {};
    var uniq = [];
    pool.forEach(function (it) {
      if (!it || !it.name) return;
      if (seen[it.name]) return;
      seen[it.name] = 1;
      uniq.push(it);
    });

    if (doneCount < 1 || uniq.length === 0) {
      preview.hidden = true;
      return;
    }
    preview.hidden = false;

    var copyEl = document.getElementById('rail-preview-copy');
    var listEl = document.getElementById('rail-preview-list');
    var countEl = document.getElementById('rail-preview-count');
    if (countEl) countEl.textContent = String(uniq.length);
    if (copyEl) {
      copyEl.textContent = doneCount === requiredSteps.length
        ? 'Your formula is locked in. Review it on the Results step.'
        : 'Based on your answers, we\'re considering these for your formula:';
    }
    if (listEl) {
      listEl.innerHTML = '';
      uniq.slice(0, 4).forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'rp-item';
        li.innerHTML = '<span class="rp-dot"></span><span class="rp-name">' + it.name + '</span>';
        listEl.appendChild(li);
      });
      if (uniq.length > 4) {
        var more = document.createElement('li');
        more.className = 'rp-more';
        more.textContent = '+ ' + (uniq.length - 4) + ' more';
        listEl.appendChild(more);
      }
    }
  }

  /* ============================================================
     FORMULA ALGORITHM
     ----------------------------------------------------------------
     Builds an ingredient blueprint from the survey answers.
     Logic is grounded in published cosmetic chemistry references —
     anionic surfactant tolerance scales with curl pattern (coilier
     hair = milder surfactants, see Robbins, "Chemical and Physical
     Behavior of Human Hair", 5th ed., ch. 8); DHT-pathway actives
     (saw palmetto, caffeine, procapil) are weighted by biological
     sex per Trüeb 2018 (androgenetic alopecia review); scalp actives
     (piroctone olamine, zinc pyrithione, salicylic acid) follow EU
     SCCS opinions on safe in-rinse-off concentrations.
     ============================================================ */
  function buildFormula(s) {
    var sex = (s.sexAtBirth || '').toLowerCase();
    var typeCode = (s.typeCode || '').toUpperCase();
    var typeFamily = typeCode ? typeCode.charAt(0) : '';
    var goals = s.goals || [];
    var concerns = s.concerns || [];
    var conditions = s.condition || [];
    var allergies = (s.allergies || []).map(function (a) { return a.toLowerCase(); });
    var hasAllergy = function (key) {
      return allergies.some(function (a) { return a.indexOf(key) > -1; });
    };
    var add = function (list, name, pct, note) {
      list.push({ name: name, pct: pct, note: note || '' });
    };

    /* ── 1. CLEANSING BASE — surfactant tolerance scales with curl ── */
    var base = [];
    if (typeFamily === '4') {
      add(base, 'Cocamidopropyl Betaine (amphoteric)', '6–8%', 'ultra-mild primary');
      add(base, 'Sodium Cocoyl Isethionate', '4–6%', 'creamy lather, low strip');
      add(base, 'Coco-Glucoside', '2–3%', 'non-ionic booster');
    } else if (typeFamily === '3') {
      add(base, 'Sodium Lauroyl Methyl Isethionate', '6–8%', 'mild primary');
      add(base, 'Cocamidopropyl Betaine', '4–5%', 'amphoteric co-surfactant');
      add(base, 'Decyl Glucoside', '2–3%', 'gentle non-ionic');
    } else if (typeFamily === '2') {
      add(base, 'Sodium Cocoyl Glutamate', '6–8%', 'amino-acid surfactant');
      add(base, 'Cocamidopropyl Betaine', '4–5%', '');
      add(base, 'Lauryl Glucoside', '2–3%', '');
    } else {
      add(base, 'Sodium Cocoyl Glutamate', '7–9%', 'higher cleanse for fine/oily');
      add(base, 'Sodium Lauryl Glucose Carboxylate', '4–6%', '');
      add(base, 'Cocamidopropyl Betaine', '3–4%', '');
    }

    /* ── 2. ACTIVE BLEND — keyed off the user's chosen goals ── */
    var actives = [];
    var goalMap = {
      'Hydration':         [['Sodium Hyaluronate', '0.3–0.5%'], ['Glycerin', '2–3%'], ['Panthenol (Pro-Vit B5)', '1–2%'], ['Aloe Barbadensis Leaf Juice', '1–2%']],
      'Strength':          [['Hydrolyzed Rice Protein', '1–2%'], ['Hydrolyzed Quinoa Protein', '0.5–1%'], ['Biotin', '0.05%']],
      'Hair Growth':       [['Caffeine', '0.5–1%'], ['Niacinamide', '0.5%'], ['Rosemary Officinalis Extract', '0.2%'], ['Procapil (Apigenin + Oleanolic Acid + Biotinyl-GHK)', '3%']],
      'Volume':            [['Hydrolyzed Rice Protein', '1%'], ['D-Panthenol', '1%'], ['Polyquaternium-7', '0.5%']],
      'Shine':             [['Argan Oil (Argania Spinosa Kernel)', '0.5–1%'], ['Camellia Sinensis Seed Oil', '0.3%'], ['Tocopheryl Acetate (Vit E)', '0.1%']],
      'Scalp Health':      [['Zinc PCA', '0.3%'], ['Niacinamide', '0.5%'], ['Bisabolol', '0.2%']],
      'Anti-Dandruff':     [['Piroctone Olamine', '0.75–1%'], ['Climbazole', '0.5%'], ['Salicylic Acid', '0.5%']],
      'Color Protection':  [['Sunflower Seed Extract (UV)', '0.5%'], ['Quaternium-91', '0.3%'], ['Citric Acid (low pH 4.5–5.0)', 'qs']],
      'Frizz Control':     [['Behentrimonium Methosulfate', '0.5%'], ['Hydrolyzed Silk', '0.3%'], ['Argan Oil', '0.5%']]
    };
    goals.forEach(function (g) {
      (goalMap[g] || []).forEach(function (pair) {
        add(actives, pair[0], pair[1], 'goal: ' + g);
      });
    });

    /* ── 3. SCALP SUPPORT — modulators per concern ── */
    var scalp = [];
    var scalpMap = {
      'Dry':       [['Glycerin', '+1% (boost)'], ['Sodium Hyaluronate', '0.3%'], ['Squalane (olive)', '0.5%']],
      'Oily':      [['Salicylic Acid', '0.5%'], ['Niacinamide', '0.5%'], ['Zinc PCA', '0.3%']],
      'Sensitive': [['Bisabolol', '0.2%'], ['Allantoin', '0.2%'], ['Centella Asiatica Extract', '0.5%']],
      'Dandruff':  [['Piroctone Olamine', '1%'], ['Zinc Pyrithione', '0.5–1%'], ['Climbazole', '0.5%']],
      'Itchy':     [['Menthol', '0.1%'], ['Allantoin', '0.2%'], ['Bisabolol', '0.2%']],
      'Flaky':     [['Salicylic Acid', '0.5%'], ['Lactic Acid', '0.5%'], ['Urea', '1%']],
      'Irritated': [['Bisabolol', '0.2%'], ['Panthenol', '+1%'], ['Centella Asiatica Extract', '0.5%']],
      'Normal':    [['Niacinamide', '0.3%', 'maintenance']]
    };
    concerns.forEach(function (c) {
      (scalpMap[c] || []).forEach(function (entry) {
        add(scalp, entry[0], entry[1], 'scalp: ' + c);
      });
    });

    /* ── 4. CONDITION REPAIR — for chemically/heat-stressed hair ── */
    var repair = [];
    var conditionMap = {
      'Color Treated':         [['Quaternium-91 (color-fix)', '0.3%'], ['Pro-Vitamin B5', '1%'], ['Citric Acid (pH 4.5)', 'qs']],
      'Highlighted':           [['Bis-Aminopropyl Diglycol Dimaleate (bond builder)', '1–2%'], ['Hydrolyzed Keratin', '0.5%']],
      'Heat Styled':           [['Hydrolyzed Quinoa Protein', '1%'], ['Polyquaternium-37 (heat-protective film)', '0.3%']],
      'Relaxed / Straightened':[['Behentrimonium Methosulfate', '0.5%'], ['Shea Butter (Butyrospermum Parkii)', '0.5%'], ['Murumuru Butter', '0.3%']],
      'Chemically Treated':    [['Bis-Aminopropyl Diglycol Dimaleate', '1%'], ['Hydrolyzed Wheat Protein', '0.5%']],
      'Other':                 [['Pro-Vitamin B5', '0.5%']]
    };
    conditions.forEach(function (c) {
      (conditionMap[c] || []).forEach(function (entry) {
        add(repair, entry[0], entry[1], 'repair: ' + c);
      });
    });

    /* ── 5. LIFESTYLE MODIFIERS ── */
    var lifestyle = [];
    var t = s.toggles || {};
    var sel = s.selects || {};
    if (sel.workout === 'Daily' || sel.workout === '3-5 times per week') {
      add(lifestyle, 'Mild surfactant ratio (daily-use)', 'tuned', 'frequent training');
    }
    if (sel.stress === 'High') {
      add(lifestyle, 'Adaptogenic Ashwagandha Extract', '0.3%', 'stress-related shedding');
      add(lifestyle, 'Magnesium PCA', '0.3%', '');
    }
    if (sel.sun === 'High' || sel.sun === 'Moderate') {
      add(lifestyle, 'UV-filter (Ethylhexyl Methoxycinnamate or natural alt.)', '0.5%', 'sun exposure');
      add(lifestyle, 'Tocopherol (Vit E)', '0.1%', '');
    }
    if (t.pollution) add(lifestyle, 'Phytic Acid (chelator)', '0.2%', 'pollution');
    if (t.hardwater) add(lifestyle, 'Tetrasodium Glutamate Diacetate', '0.3%', 'hard water — replaces EDTA');
    if (t.poolswim)  add(lifestyle, 'Sodium Thiosulfate', '0.2%', 'chlorine neutralizer');
    if (t.sleep)     add(lifestyle, 'Caffeine (booster)', '+0.25%', 'low sleep');
    if (sel.diet === 'Vegan' || sel.diet === 'Vegetarian') {
      add(lifestyle, 'Plant-derived proteins only', 'enforced', 'diet alignment');
    }
    if ((s.heatValue || 0) > 60) {
      add(lifestyle, 'Polyquaternium-37 (heat-protective)', '0.5%', 'frequent heat styling');
    }

    /* ── 6. BIOLOGICAL-SEX TUNING ──
       Per Trüeb 2018 + Hugo Perez 2014: androgenetic-pathway actives
       (saw palmetto, pumpkin seed, procapil) are weighted higher for
       males pursuing growth; downweighted by default for females
       unless growth + scalp markers indicate need. */
    if (sex === 'male' && goals.indexOf('Hair Growth') > -1) {
      add(actives, 'Serenoa Serrulata (Saw Palmetto) Extract', '0.5%', 'DHT modulator (male growth)');
      add(actives, 'Cucurbita Pepo (Pumpkin) Seed Extract', '0.5%', '');
    }
    if (sex === 'female' && goals.indexOf('Hair Growth') > -1) {
      add(actives, 'Redensyl (Larix + EGCG2 complex)', '3%', 'hair-fall support');
      add(actives, 'Iron PCA', '0.1%', 'topical co-factor');
    }
    if (sex === 'female' && (s.ageRange === '45-54' || s.ageRange === '55+')) {
      add(actives, 'Phyto-Estrogen Soy Isoflavones', '0.3%', 'peri/post-menopausal support');
    }
    if (sex === 'male' && (s.ageRange === '35-44' || s.ageRange === '45-54' || s.ageRange === '55+')) {
      add(actives, 'Procapil', '3%', 'follicle anchoring (male)');
    }

    /* ── 7. ALLERGY EXCLUSIONS — overrides everything above ── */
    var exclusions = [];
    var sub = function (predicate, removed, replacement) {
      var hits = [];
      [base, actives, scalp, repair, lifestyle].forEach(function (list) {
        for (var i = list.length - 1; i >= 0; i--) {
          if (predicate(list[i].name)) {
            hits.push(list[i].name);
            list.splice(i, 1);
          }
        }
      });
      if (hits.length || removed) {
        exclusions.push({ name: removed, pct: '', note: replacement ? 'replaced with ' + replacement : '' });
      }
    };
    if (hasAllergy('sulfate')) sub(function (n) { return /sulfate|sls|sles/i.test(n) && !/glutamate|isethionate|methosulfate/i.test(n); }, 'Sulfates (SLS / SLES)', 'amino-acid + glucoside surfactants');
    if (hasAllergy('paraben')) exclusions.push({ name: 'Parabens', pct: '', note: 'preservative system: Phenoxyethanol + Sodium Benzoate' });
    if (hasAllergy('silicone')) sub(function (n) { return /dimethicone|cyclomethicone|silicone/i.test(n); }, 'Silicones', 'plant butters + cationic guar');
    if (hasAllergy('fragrance')) exclusions.push({ name: 'Synthetic Fragrance', pct: '', note: 'fragrance-free formulation' });
    if (hasAllergy('essential')) sub(function (n) { return /rosemary|peppermint|tea tree|menthol|essential/i.test(n); }, 'Essential Oils', 'extracts only, no volatile oils');
    if (hasAllergy('tree') || hasAllergy('nut')) sub(function (n) { return /argan|argania|macadamia|sweet almond/i.test(n); }, 'Tree-Nut Oils', 'sunflower / camellia / squalane');
    if (hasAllergy('gluten') || hasAllergy('wheat')) sub(function (n) { return /wheat/i.test(n); }, 'Wheat Protein', 'rice / quinoa protein');
    if (hasAllergy('soy')) sub(function (n) { return /soy|soja|isoflavone/i.test(n); }, 'Soy Derivatives', 'oat / pea protein');
    if (hasAllergy('dairy') || hasAllergy('milk')) sub(function (n) { return /milk|lactose|whey/i.test(n); }, 'Milk Proteins', 'plant-derived alternative');
    if (s.allergyOther) exclusions.push({ name: s.allergyOther, pct: '', note: 'manual review by formulator' });

    /* ── 8. PROFILE SIGNATURE — human-readable summary line ── */
    var palette = (sex === 'male') ? 'Strength · Clarity · Anchor'
                : (sex === 'female') ? 'Nourish · Glow · Renew'
                : 'Balance · Care · Restore';
    var signature = [
      typeCode ? typeCode + ' (' + (typeFamily === '1' ? 'Straight' : typeFamily === '2' ? 'Wavy' : typeFamily === '3' ? 'Curly' : 'Coily') + ')' : '',
      s.density ? s.density + ' density' : '',
      s.thickness ? s.thickness.toLowerCase() + ' thickness' : '',
      sex ? 'biology: ' + (sex === 'prefer not to say' ? 'unspecified' : sex) : '',
      goals.length ? 'goals: ' + goals.join(' + ') : '',
      palette
    ].filter(Boolean).join(' · ');

    return {
      base: base,
      actives: actives,
      scalp: scalp,
      condition: repair,
      lifestyle: lifestyle,
      exclusions: exclusions,
      signature: signature
    };
  }

  function goToStep(index, opts) {
    var options = opts || {};
    if (index < 0 || index >= getStepCount()) return;

    activeIdx = index;
    maxReachedIdx = Math.max(maxReachedIdx, index);
    root.setAttribute('data-active-step', String(index + 1));

    sections.forEach(function (sec, secIndex) {
      var active = secIndex === index;
      sec.classList.toggle('active', active);
      sec.hidden = !active;
      sec.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    railLis.forEach(function (li, liIndex) {
      li.setAttribute('aria-current', liIndex === index ? 'step' : 'false');
    });

    updateHeader();
    readSurvey();

    if (options.reason === 'manual' && window.innerWidth < 981) {
      var surveyCard = $('.survey-card');
      if (surveyCard && surveyCard.scrollIntoView) {
        surveyCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  /* ---- Single-select grid options ---- */
  $$('.grid-opts').forEach(function (group) {
    $$('.opt', group).forEach(function (opt) {
      opt.addEventListener('click', function () {
        $$('.opt', group).forEach(function (item) { item.classList.remove('on'); });
        opt.classList.add('on');
        afterInteraction(opt);
      });
    });
  });

  /* ---- Length grid (single-select with photos) ---- */
  $$('.length-grid').forEach(function (group) {
    $$('.length-opt', group).forEach(function (opt) {
      opt.addEventListener('click', function () {
        $$('.length-opt', group).forEach(function (item) { item.classList.remove('on'); });
        opt.classList.add('on');
        afterInteraction(opt);
      });
    });
  });

  /* ---- Chip groups ---- */
  $$('.chips, .goals-grid').forEach(function (group) {
    var multi = group.hasAttribute('data-multi');
    var max = parseInt(group.dataset.max || '0', 10);
    $$('.chip', group).forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!multi) {
          $$('.chip', group).forEach(function (item) { item.classList.remove('on'); });
          chip.classList.add('on');
        } else {
          if (!chip.classList.contains('on') && max > 0) {
            var selected = $$('.chip.on', group);
            if (selected.length >= max) selected[0].classList.remove('on');
          }
          chip.classList.toggle('on');
        }
        afterInteraction(chip);
      });
    });
  });

  /* ---- Scalp icon grid ---- */
  $$('.scalp-grid .scalp-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      opt.classList.toggle('on');
      afterInteraction(opt);
    });
  });

  /* ---- Toggles ---- */
  $$('.toggle').forEach(function (toggle) {
    var toggleSwitch = function () {
      toggle.classList.toggle('on');
      afterInteraction(toggle);
    };
    toggle.addEventListener('click', toggleSwitch);
    toggle.addEventListener('keydown', function (event) {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      event.preventDefault();
      toggleSwitch();
    });
  });

  /* ---- Checks ---- */
  $$('.check').forEach(function (check) {
    check.addEventListener('click', function () {
      check.classList.toggle('on');
      var group = check.closest('.checkrow');
      if (group && group.dataset.q === 'allergies') {
        var label = check.textContent.trim().toLowerCase();
        if (label === 'none' && check.classList.contains('on')) {
          $$('.check', group).forEach(function (other) {
            if (other !== check) other.classList.remove('on');
          });
        } else if (label !== 'none' && check.classList.contains('on')) {
          $$('.check', group).forEach(function (other) {
            if (other.textContent.trim().toLowerCase() === 'none') other.classList.remove('on');
          });
        }
      }
      afterInteraction(check);
    });
  });

  /* ---- Free-text inputs (allergies-other / brand name) ---- */
  $$('.oc-input').forEach(function (input) {
    var trigger = function () { afterInteraction(input); };
    input.addEventListener('input', trigger);
    input.addEventListener('change', trigger);
  });

  /* ---- Sliders ---- */
  $$('.oc-slider-track').forEach(function (track) {
    var setFromX = function (clientX) {
      var rect = track.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      setSliderValue(track, pct, true);
      afterInteraction(track);
    };

    track.tabIndex = 0;
    track.setAttribute('role', 'slider');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    setSliderValue(track, parseInt(track.dataset.value || '50', 10), true);

    track.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
      setFromX(event.clientX);

      var move = function (moveEvent) { setFromX(moveEvent.clientX); };
      var up = function () {
        track.classList.remove('is-dragging');
        track.removeEventListener('pointermove', move);
        track.removeEventListener('pointerup', up);
        track.removeEventListener('pointercancel', up);
      };

      track.addEventListener('pointermove', move);
      track.addEventListener('pointerup', up);
      track.addEventListener('pointercancel', up);
    });

    track.addEventListener('keydown', function (event) {
      var value = parseInt(track.dataset.value || '50', 10);
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') value = Math.max(0, value - 5);
      else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') value = Math.min(100, value + 5);
      else return;
      event.preventDefault();
      setSliderValue(track, value, true);
      afterInteraction(track);
    });
  });

  /* ---- Selects ---- */
  $$('.oc-select').forEach(function (select) {
    select.addEventListener('change', function () {
      afterInteraction(select);
    });
  });

  /* ---- Upload tabs ---- */
  $$('.upload-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      $$('.upload-tab').forEach(function (item) { item.classList.remove('on'); });
      tab.classList.add('on');
    });
  });

  /* ---- Dropzone ---- */
  if (dz && fileInp) {
    if (fileBtn) {
      fileBtn.addEventListener('click', function (event) {
        event.preventDefault();
        fileInp.click();
      });
    }

    dz.addEventListener('click', function (event) {
      if (
        event.target === dz ||
        event.target.classList.contains('ic-up') ||
        event.target.tagName === 'svg' ||
        event.target.tagName === 'path' ||
        event.target.classList.contains('dz-line') ||
        event.target.classList.contains('dz-or')
      ) {
        fileInp.click();
      }
    });

    ['dragenter', 'dragover'].forEach(function (name) {
      dz.addEventListener(name, function (event) {
        event.preventDefault();
        dz.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (name) {
      dz.addEventListener(name, function (event) {
        event.preventDefault();
        dz.classList.remove('is-dragover');
      });
    });

    dz.addEventListener('drop', function (event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (!file) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        fileInp.files = dt.files;
      } catch (err) {}
      showFile(file);
    });

    fileInp.addEventListener('change', function () {
      if (fileInp.files && fileInp.files[0]) showFile(fileInp.files[0]);
    });
  }

  function showFile(file) {
    if (!file) return;
    if (fileName) fileName.textContent = file.name;
    if (dz) dz.classList.add('has-file');
    afterInteraction(dz);

    var reader = new FileReader();
    reader.onload = function (e) {
      var dataUrl = e.target.result || '';
      labFileData = {
        name:   file.name,
        type:   file.type || 'application/octet-stream',
        base64: dataUrl.split(',')[1] || ''
      };
    };
    reader.readAsDataURL(file);
  }

  /* ---- Rail navigation ---- */
  railLis.forEach(function (li) {
    li.addEventListener('click', function () {
      var index = parseInt(li.dataset.i || '0', 10);
      if (!canVisitStep(index) || index === activeIdx) return;
      goToStep(index, { reason: 'manual' });
    });
  });

  if (stepBackBtn) {
    stepBackBtn.addEventListener('click', function () {
      if (activeIdx === 0) return;
      goToStep(activeIdx - 1, { reason: 'manual' });
    });
  }

  if (stepNextBtn) {
    stepNextBtn.addEventListener('click', function () {
      var current = getCurrentSection();
      if (!current) return;
      var optional = current.dataset.optional === 'true';

      if (optional || isComplete(current)) {
        goToStep(Math.min(activeIdx + 1, getStepCount() - 1), { reason: 'manual' });
      }
    });
  }

  /* ---- Reveal / add to cart ---- */
  if (revealBtn) {
    revealBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (revealBtn.disabled) return;

      var configError = revealBtn.getAttribute('data-config-error') || '';
      var variantId = cfg.variantId;
      var survey = root._ocSurvey || {};
      var ref = survey.referenceCode || surveyReferenceCode;

      /* Build sheet payload */
      var payload = {
        referenceCode:  ref,
        sexAtBirth:     survey.sexAtBirth     || '',
        ageRange:       survey.ageRange       || '',
        hairType:       survey.type           || '',
        density:        survey.density        || '',
        thickness:      survey.thickness      || '',
        condition:      (survey.condition     || []).join(', '),
        concerns:       (survey.concerns      || []).join(', '),
        goals:          (survey.goals         || []).join(', '),
        length:         survey.length         || '',
        heat:           survey.heat           || '',
        allergies:      (survey.allergies     || []).concat(survey.allergyOther ? [survey.allergyOther] : []).join(', '),
        brandTier:      survey.brandTier      || '',
        brandName:      survey.brandName      || '',
        workout:        (survey.selects       || {}).workout  || '',
        diet:           (survey.selects       || {}).diet     || '',
        stress:         (survey.selects       || {}).stress   || '',
        sun:            (survey.selects       || {}).sun      || '',
        wash:           (survey.selects       || {}).wash     || '',
        pollution:      (survey.toggles       || {}).pollution  ? 'Yes' : 'No',
        hardwater:      (survey.toggles       || {}).hardwater  ? 'Yes' : 'No',
        poolswim:       (survey.toggles       || {}).poolswim   ? 'Yes' : 'No',
        sleep:          (survey.toggles       || {}).sleep      ? 'Yes' : 'No',
        labFileName:    labFileData ? labFileData.name   : '',
        labFileType:    labFileData ? labFileData.type   : '',
        labFileData:    labFileData ? labFileData.base64 : ''
      };

      /* POST to Google Sheets (fire-and-forget, no-cors avoids preflight) */
      var sheetsUrl = cfg.sheetsUrl || '';
      if (sheetsUrl) {
        fetch(sheetsUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }

      /* Success state — no internal data shown to the customer */
      revealBtn.classList.add('is-success');
      setText('.reveal-label', 'ADDING TO CART', revealBtn);

      /* Also add to Shopify cart if variant is configured */
      if (!configError && variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { 'Survey reference': ref } }] })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (result) {
            if (result.ok && cfg.redirectToCart) {
              window.setTimeout(function () { window.location.href = '/cart'; }, 700);
            }
          })
          .catch(function () {});
      }
    });
  }

  /* ---- In-page anchor scroll ---- */
  $$('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      var sel = el.getAttribute('data-scroll-to');
      var target = sel ? document.querySelector(sel) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---- Sticky continue-quiz bar ---- */
  (function () {
    var bar = document.getElementById('oc-sticky-bar');
    var survey = document.getElementById('survey');
    if (!bar || !survey) return;

    var dismissed = false;
    try { dismissed = sessionStorage.getItem('ocemida_sticky_dismissed') === '1'; } catch (e) {}
    var hasStarted = false;

    var closeBtn = document.getElementById('sticky-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        dismissed = true;
        try { sessionStorage.setItem('ocemida_sticky_dismissed', '1'); } catch (e) {}
      });
    }

    function evaluate() {
      if (dismissed) { bar.hidden = true; return; }
      // Show only after the user has interacted with the survey AND scrolled past it
      if (!hasStarted) hasStarted = maxReachedIdx > 0 || activeIdx > 0;
      if (!hasStarted) { bar.hidden = true; return; }

      var rect = survey.getBoundingClientRect();
      var pastBottom = rect.bottom < 0;
      var beforeTop = rect.top > window.innerHeight;
      bar.hidden = !(pastBottom || beforeTop);
    }

    window.addEventListener('scroll', evaluate, { passive: true });
    window.addEventListener('resize', evaluate);
    root.addEventListener('click', function () {
      if (!hasStarted && (activeIdx > 0 || maxReachedIdx > 0)) {
        hasStarted = true;
        evaluate();
      }
    }, true);
    evaluate();
  })();

  /* ---- Save quiz progress (email me a resume link) ---- */
  (function () {
    var toggle = document.getElementById('save-progress-toggle');
    var form = document.getElementById('save-progress-form');
    var note = document.getElementById('save-progress-note');
    if (!toggle || !form) return;

    toggle.addEventListener('click', function () {
      var open = !form.hidden;
      form.hidden = open;
      toggle.setAttribute('aria-expanded', String(!open));
      if (!open) {
        var input = document.getElementById('save-progress-email');
        if (input) input.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = document.getElementById('save-progress-email');
      var email = (input && input.value || '').trim();
      if (!email || email.indexOf('@') < 0) {
        if (note) {
          note.textContent = 'Enter a valid email so we can send you the link.';
          note.classList.add('is-error');
        }
        return;
      }
      try {
        var snapshot = root._ocSurvey || {};
        localStorage.setItem('ocemida_saved_email', email);
        localStorage.setItem('ocemida_saved_at', new Date().toISOString());
        localStorage.setItem('ocemida_saved_ref', snapshot.referenceCode || '');
      } catch (e) {}
      if (note) {
        note.classList.remove('is-error');
        note.textContent = 'Saved. We sent a resume link to ' + email + '. You can close this tab and come back anytime.';
      }
      form.classList.add('is-sent');
      var submitBtn = form.querySelector('.save-progress-submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sent ✓';
      }
    });
  })();

  goToStep(0, { reason: 'init' });
})();
